import { render, staticRenderFns } from "./ScriptLinkObjectDrawer.vue?vue&type=template&id=3db2c2b2&"
import script from "./ScriptLinkObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./ScriptLinkObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports